<template>
  <div class="version1-middle-bottom">
    <div class="left">
      <div class="middle-title">
        <img src="../../../../../static/version1/标题箭头左.png" alt="">
        <span class="text">专利海外布局</span>
        <img src="../../../../../static/version1/标题箭头右.png" alt="">
      </div>
      <div class="num-text">
        <swiper ref="mySwiper" :options="swiperOption">
          <swiperSlide :key="index" v-for="(item, index) in pctArr">
            <span :title="item.name">{{ item.name }}: {{ item.value }}</span>
          </swiperSlide>
        </swiper>
      </div>
      <Bar :options="options" @echartClick="echartClickP"></Bar>
    </div>
    <div class="right">
      <div class="middle-title">
        <img src="../../../../../static/version1/标题箭头左.png" alt="">
        <span class="text">{{ title2 || '申请人合作情况' }}</span>
        <img src="../../../../../static/version1/标题箭头右.png" alt="">
      </div>
      <div class="total" v-if="!useNewGovTemplate"><span>合作专利总数:{{ opeTotal }}</span></div>
      <Bar :options="appOptions" @echartClick="echartClickH"></Bar>
    </div>

  </div>
</template>

<script>
import { getValuePCT, getValueCooperate, agencyRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
import Bar from '@/components/echarts/Bar'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'

export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {},
      total: 0,
      opeTotal: 0,
      appOptions: {},
      relationChart: [],
      value: [],
      compName: [],
      pctArr: [],
      swiperOption: {
        init: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        direction: 'vertical',
        autoHeight: true,
        loopAdditionalSlides: 1,
        slidesPerView: 1, // 页面中的板块数量
        loop: true,
        autoplay: {
          delay: 2000
          // disableOnInteraction: false
        }
      }
    }
  },
  components: {
    Bar,
    swiper,
    swiperSlide
  },
  computed: {
    ...mapState('title', ['title2']),
    ...mapState('user', ['useNewGovTemplate']),
    PCTSwiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.init()
    this.initChart()
  },
  methods: {
    echartClickH(params) {
      const name = params.name.split(':')
      if (params.componentType === 'radar') {
        if (this.useNewGovTemplate) {
          this.jumpIpi(`代理机构(精确)=(${name[0]}) and 专利类型=(发明授权 or 实用新型 or 外观设计)`)
        } else {
          this.jumpIpi(`申请人数量>(1) and 申请人=（${name[0]}）`, 'isMerge', 'publicOrder')
        }
      }
    },
    echartClickP(params) {
      let exp = '数据源=' + params.data.name
      if (params.data.name === '其他') {
        exp = `数据源=(US or EP or JP or KR or GB or FR or DE or RU or CH or WO or OTHER) ${params.data.exp}`
      }
      this.jumpIpi(exp, 'isMerge', 'publicOrder')
    },
    async init() {
      const result = await getValuePCT()
      const { datas, total } = result[this.dataMapping]
      const obj = {
        '世界知识产权组织国际局(WIPO)': 'WIPO',
        美国: 'US',
        '欧洲专利局(EPO)': 'EPO',
        日本: 'JP',
        其他: 'OTHER'
      }
      datas.forEach(item => {
        item.value = item.count
        item.value = item.count
        if (item.name.indexOf('WO') !== -1) {
          item.name = 'WIPO'
        }
        if (item.name.indexOf('EP') !== -1) {
          item.name = 'EPO'
        }
        item.type = obj[item.name]

        // item.name = item.name + item.per
      })
      this.pctArr = datas
      this.total = total

      this.options = {
        title: {
          text: this.total,
          textStyle: {
            fontSize: 14,
            color: '#00A2D1',
            height: 1,
            lineHeight: 1
          },
          subtext: '总数',
          subtextStyle: {
            fontSize: 12,
            color: '#000',
            height: 1,
            lineHeight: 1

          },
          textVerticalAlign: 'middle',
          padding: 0,
          left: 'center',
          top: '45%'
        },
        color: [
          '#0071FC',
          '#00FBF9',
          '#008BF1',
          '#00CDFA',
          '#0030FB'
        ],
        radar: {
          zlevel: -1,
          shape: 'circle',
          scale: true,
          indicator: [
            {
              max: 100,
              min: -10
            },
            {
              max: 100,
              min: -10
            },
            {
              max: 100,
              min: -10
            },
            {
              max: 100,
              min: -10
            },
            {
              max: 100,
              min: -10
            },
            {
              max: 100,
              min: -10
            }
          ],
          center: [
            '50%',
            '50%'
          ],
          radius: '90%',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(9,135,185,.3)'
            }
          },
          splitArea: {
            areaStyle: {
              color: ['transparent', 'RGBA(21, 94, 129, .4)', 'RGBA(21, 94, 129, .4)', 'RGBA(21, 94, 129, .4)']
            }
          },

          splitLine: {
            lineStyle: {
              color: [
                '#0876A4',
                'RGBA(21, 94, 129, 0)',
                'RGBA(21, 94, 129, 0)',
                'RGBA(21, 94, 129, 0)',
                'RGBA(6, 148, 204, .6)',
                '#02A6E6'
              ]
            }
          }
        },
        tooltip: {
          show: true,
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            radius: [
              '0%',
              '32%'
            ],
            labelLine: {
              show: false
            },
            silent: true,
            avoidLabelOverlap: false,
            data: [
              {
                name: '',
                value: 0,
                itemStyle: {
                  normal: {
                    color: '#D6FFFF'
                  }
                }
              }
            ]
          },
          {
            stack: 'a',
            type: 'pie',
            radius: [
              '32%',
              '72%'
            ],
            roseType: 'area',
            zlevel: 10,
            label: {
              normal: {
                show: true,
                position: 'outside',
                color: '#fff',
                formatter: '{b}: {d}%',
                distanceToLabelLine: 26
              }

            },
            labelLine: {
              normal: {
                show: false,
                length: 15
              }
            },
            data: datas
          }
        ]
      }
      this.$nextTick(() => {
        this.PCTSwiper.init()
      })
    },
    async initChart() {
      if (this.useNewGovTemplate) {
        await this.getAgencyRange()
      } else {
        await this.getValue()
      }
      this.appOptions = {
        textStyle: {
          fontSize: this.useNewGovTemplate ? '14' : '13',
          color: '#fff'
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: (params) => {
            let text = this.name + '合作专利数' + '</br>'
            if (this.useNewGovTemplate) {
              text = ''
            }
            const color = ['#EF6896', '#6DC8EC', '#1E9493', '#5AD8A6', '#F6BD16']
            this.relationChart.forEach((item, i) => {
              text += `<div style="display: flex;align-items:center"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${color[i]}"></span>` + '<div style="flex:1;display: flex;justify-content:space-between;align-items:center">' +
                item.name + `<span style="font-weight: 800">${item.value}</span></div></div>` + '</br>'
            })
            return text
          }
        },
        radar: {
          triggerEvent: true,
          indicator: this.compName,
          radius: '65%',
          axisName: {
            show: true,
            padding: [0, -5, -10, -5],
            formatter: (a, indicator) => {
              // return indicator.text + ': \n' + indicator.value
              const params = indicator.text + ': ' + indicator.value
              let newParamsName = ''
              const paramsNameNumber = params.length
              const provideNumber = 11 // 一行显示几个字 然后就超过字数就会自动换行
              const rowNumber = Math.ceil(paramsNameNumber / provideNumber)
              if (paramsNameNumber > provideNumber) {
                for (let p = 0; p < rowNumber; p++) {
                  let tempStr = ''
                  const start = p * provideNumber
                  const end = start + provideNumber
                  if (p === rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber)
                  } else {
                    tempStr = params.substring(start, end) + '\n'
                  }
                  newParamsName += tempStr
                }
              } else {
                newParamsName = params
              }
              return newParamsName
            }
          }
        },

        series: [
          {
            symbol: 'none', // 是否展示节点
            lineStyle: {
              width: 1
            },
            areaStyle: {
              color: '#68CAFE'
            },
            type: 'radar',
            data: [{
              value: this.value,
              name: this.name + '合作专利数'
            }],
            emphasis: {
              areaStyle: {
                color: '#68CAFE'
              }
            }
          }
        ]
      }
    },
    async getValue() {
      let query = {
        viewName: 'APPLICANT_COOPERATION_ANALYSIS',
        firstDim: 'COOPERATIVE_OBJ',
        querys: [
          {
            property: 'TOP_COOPERATIVE_PATENT_NUM',
            operation: 'LESS_EQUAL',
            value: '5'
          }
        ],
        measureFields: ['application_num']
      }
      if (this.isXZH) query = {}
      const data = await getValueCooperate(query)
      if (data[this.dataMapping]) {
        const { result: { relationChart } } = JSON.parse(data[this.dataMapping])
        this.opeTotal = relationChart.data[0].value
        this.name = relationChart.data[0].name
        const dataArr = []
        let max = 0
        relationChart.links.forEach(item => {
          item.name = item.target
          if (item.value > max) {
            max = item.value
          }
          dataArr.push({
            text: item.target,
            value: item.value
          })
          this.value.push(item.value)
        })
        dataArr.forEach(item => {
          this.compName.push({
            text: item.text,
            max: max + 20,
            value: item.value
          })
        })
        this.relationChart = relationChart.links
      }
    },
    async getAgencyRange() {
      const res = await agencyRange()
      if (res.code === 200) {
        const dataArr = []
        let max = 0
        res.data.forEach(item => {
          item.value = item.count
          if (item.value > max) {
            max = item.value
          }
          dataArr.push({
            text: item.name,
            value: item.count
          })
          this.value.push(item.value)
        })
        dataArr.forEach(item => {
          this.compName.push({
            text: item.text,
            max: max + 20,
            value: item.value
          })
        })
        this.relationChart = res.data
      }
    }
  }
}
</script>
